import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';

import '../node_modules/@mdi/font/css/materialdesignicons.css';
import './assets/img/gkv-eemdijk.jpg';

// vuetify
import './shared/styles/vueSettings.scss';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

const app = createApp(App);

// Define the church color theme
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'churchTheme',
    themes: {
      churchTheme: {
        dark: false,
        colors: {
          primary: '#91BD65', // NGK primary green
          'on-primary': '#ffffff',
          brandDark: '#006633', // dark support green from stylesheet
          'on-brandDark': '#ffffff',
          secondary: '#424242', // anthracite
          accent: '#50568F', // NGK blue from stylesheet
          'on-accent': '#ffffff',
          highlight: '#EEB336', // NGK orange from stylesheet
          'on-highlight': '#3a2b00',
          background: '#ffffff', // white
          surface: '#ffffff',
          error: '#b71c1c',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FB8C00'
        }
      }
    }
  }
});

app.use(createPinia());
app.use(router);
app.use(vuetify);

app.mount('#app');
